import React from "react";

import styles from "../../style/ChatBotWindow.module.css";

interface SendButtonProps {
  onClick: () => void;
  disabled: boolean;
}

const SendButton: React.FC<SendButtonProps> = ({ onClick, disabled }) => {
  return (
    <button
      className={styles.sendButton}
      disabled={disabled}
      onClick={onClick}
      aria-label="Send message"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 6L12 18M12 6L7 11M12 6L17 11"
          stroke="var(--iconInverse)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default SendButton;
